module.exports = __webpack_public_path__ + "img/44.ae7b2e3f.svg";